import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {LanguageDomainModel} from "../language/language.domain-model";
import {UserCountryModel} from "../user-country/user-country.model";
import {LocaleApiModel} from "./locale.api-model";
import {computed, makeObservable, observable} from "mobx";
import {COUNTRYID_TO_CURRENCY_MAP} from "../../../../core/app/consts";

export class LocaleDomainModel extends BaseDomainModel {
  apiModel: LocaleApiModel;
  @observable language: LanguageDomainModel;
  userCountryModel: UserCountryModel;

  constructor(apiModel: LocaleApiModel, language: LanguageDomainModel, userCountryModel: UserCountryModel) {
    super(apiModel);

    this.language = language;
    this.userCountryModel = userCountryModel;

    makeObservable(this);
  }

  get userCountryId(): Number {
    return this.apiModel.userCountryId;
  }

  @computed get bettingZoneLang() {
    let bettingZoneLang = '';
    const map = {
      'es': {
        '112': 'es-pe',
        '10': 'es-ar',
        '109': 'es-co',
        '28': 'es-cl',
      },
      'pt-br': {
        '21': 'pt-br',
      },
      'es-mx': {
        '31': 'es-mx',
      }
    }

    const byCountryId = map[this.language.displayName];

    bettingZoneLang = byCountryId?.[`${this.userCountryId}`];

    if(!bettingZoneLang) {
      const shallowMap = {
        'pt-br/apostas': 'pt-br',
        'es/apuestas-peru': 'es-pe',
        'es/apuestas-argentina': 'es-ar',
        'es/apuestas-colombia': 'es-co',
        'es/apuestas-chile': 'es-cl',
        'es-mx/apuestas-mexico': 'es-mx'
      }

      const includeInLocation = Object.keys(shallowMap).find(key => window.location.pathname.includes(key));

      bettingZoneLang = shallowMap[includeInLocation];
    }

    return bettingZoneLang;
  }

  @computed get isBettingZoneValidByLangAndCountry() {
    const map = {
      'es': {
        '112': 'es-pe',
        '10': 'es-ar',
        '109': 'es-co',
        '28': 'es-cl',
      },
      'pt-br': {
        '21': 'pt-br',
      },
      'es-mx': {
        '31': 'es-mx',
      }
    }

    const byCountryId = map[this.language.displayName];

    return byCountryId?.[`${this.userCountryId}`];
  }

  get currency() {
    return COUNTRYID_TO_CURRENCY_MAP[this.userCountryId] || '$';
  }
}
